import { Input, MLPVersion, useTranslation } from '@nextgen-web-framework/all';
import styles from './shopfinder.module.scss';
import { SearchFieldProps } from './types/propsTypes';

const SearchField = ({ handleSearchShop, searchText, handleSearchClearButton }: SearchFieldProps) => {
  const t = useTranslation();
  const handleShopSearch = (value: string) => {
    handleSearchShop(value);
  };
  return (
    <div className={styles['pickup-postalCode-field']} data-testid={'search-field-testid'}>
      <Input
        id="shop-id"
        data-testid="pickup-postalCode"
        value={searchText}
        name="pickupPostalCode"
        className={styles['pickup-postalCode']}
        inputIcon={searchText.length ? { iconName: 'close' } : undefined}
        inputIconOnClick={() => handleSearchClearButton()}
        label={t('web.shopFinder.searchAmShop')}
        onChange={(val) => {
          handleShopSearch(val.target.value);
        }}
        mlpVersion={MLPVersion.TWO}
      />
    </div>
  );
};

export default SearchField;
